import { action, makeObservable, observable } from 'mobx';
import { randomIntFromInterval, shuffle } from '../utils';
import { payTable } from '../constants';
import { gameStore } from './gameStore';
import { IBet, IHistoryItem, IHistoryTicket } from '../interfaces/bet';

class BetStore {
  numbers: number[] = [];
  selectedNumbers: number[] = [];
  amount = gameStore.defaultBetAmount;
  payTable = payTable;
  currentBets: IBet[] = [];
  allBetsCount = 0;
  betToEdit: IBet | null = null;
  ticketToReBet: IHistoryTicket | null = null;
  historyItemToReBet: IHistoryItem | null = null;

  constructor() {
    makeObservable(this, {
      amount: observable,
      betToEdit: observable,
      allBetsCount: observable,
      currentBets: observable,
      selectedNumbers: observable,
      ticketToReBet: observable,
      historyItemToReBet: observable,
      selectNumber: action,
      clearSelectedNumbers: action,
      selectRandomNumbers: action,
      selectRandomNumbersByCount: action,
      setAmount: action,
      unshiftCurrentBet: action,
      pushCurrentBet: action,
      setCurrentBets: action,
      clearCurrentBets: action,
      setAllBetsCount: action,
      setBetToEdit: action,
      setTicketToReBet: action,
      setHistoryItemToReBet: action,
    });
    this.initializeNumbers();
  }

  selectNumber = (number: number): boolean => {
    const index = this.selectedNumbers.indexOf(number);
    if (index === -1) {
      if (this.selectedNumbers.length >= gameStore.maxNumberCountPerTicket)
        return false;

      this.selectedNumbers.push(number);
    } else {
      if (!this.betToEdit || (this.betToEdit && this.selectedNumbers.length > 1)) {
        this.selectedNumbers.splice(index, 1)
      }
    }

    return true;
  }

  clearSelectedNumbers = () => {
    if (this.betToEdit) {
      this.selectedNumbers = [this.selectedNumbers[0]];
    } else {
      this.selectedNumbers = [];
    }
  }

  selectRandomNumbers = () => {
    const count = randomIntFromInterval(1, gameStore.maxNumberCountPerTicket);
    this.selectRandomNumbersByCount(count);
  }

  selectRandomNumbersByCount = (count: number) => {
    const shuffledNumbers = shuffle(this.numbers);
    this.selectedNumbers = shuffledNumbers.slice(0, count);
  }

  setAmount = (amount: number) => {
    this.amount = amount;
  }

  setAllBetsCount = (count: number) => {
    this.allBetsCount = count;
  }

  setCurrentBets = (currentBets: IBet[]) => {
    this.currentBets = currentBets;
  }

  unshiftCurrentBet = (bet: IBet) => {
    this.currentBets.unshift(bet);
  }

  pushCurrentBet = (bet: IBet) => {
    this.currentBets.push(bet);
  }

  clearCurrentBets = () => {
    this.currentBets = [];
  }

  setBetToEdit = (bet: IBet | null) => {
    this.betToEdit = bet;
    if (bet) {
      this.selectedNumbers = [...bet.numbers];
    }
  }

  setTicketToReBet = (data: IHistoryTicket | null) => {
    this.ticketToReBet = data;
  }

  setHistoryItemToReBet = (data: IHistoryItem | null) => {
    this.historyItemToReBet = data;
  }

  private initializeNumbers() {
    for (let i = 1; i <= 80; i++) {
      this.numbers.push(i);
    }
  }
}

export const betStore = new BetStore();
